import { English, Development, EnglishAustralia, EnglishUnitedKingdom, French, FrenchCanada, Spanish, German } from './locale-codes';
import { CheckEnvService } from '../../services/check-env-service';

const areWeInDevEnvironment = CheckEnvService.areWeInDevEnvironment();

export const initialLocaleState = English;
export const initialAvailableLocaleState = [
  English,
  EnglishAustralia,
  EnglishUnitedKingdom,
  French,
  FrenchCanada,
  Spanish,
  German,
  ...(areWeInDevEnvironment ? [Development] : []),
];
